import React from "react";

import {
  applyThemePreference,
  getStoredThemePreference,
  setStoredThemePreference,
} from "../theme/darkMode";

// Lightweight replacement for a ThemeContext hook used throughout the app.
// It derives theme from the document <html> `dark` class (same mechanism
// used in `src/theme/darkMode.js`) and updates on changes.
export function useTheme() {
  const [themePreference, setThemePreference] = React.useState(() =>
    getStoredThemePreference() || "system"
  );

  const [theme, setThemeState] = React.useState(() =>
    typeof document !== "undefined" &&
    document.documentElement.classList.contains("dark")
      ? "dark"
      : "light"
  );

  // Set user preference: "light" | "dark" | "system"
  const setTheme = (newPreference) => {
    const next = newPreference || "system";
    setThemePreference(next);
    setStoredThemePreference(next);
    applyThemePreference(next);
  };

  React.useEffect(() => {
    // Ensure preference is applied (in case hook mounts after initTheme)
    applyThemePreference(themePreference);

    const observer = new MutationObserver(() => {
      setThemeState(
        typeof document !== "undefined" &&
          document.documentElement.classList.contains("dark")
          ? "dark"
          : "light"
      );
    });
    observer.observe(document.documentElement, { attributes: true });
    return () => observer.disconnect();
  }, [themePreference]);

  return { theme, themePreference, setTheme };
}
